import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const ProjectsGallerySection = () => {
  const { language } = useLanguage();
  const [visibleItems, setVisibleItems] = useState(6);
  const [activeCategory, setActiveCategory] = useState('all');
  const [isIntersecting, setIsIntersecting] = useState(false);

  // Example project data - in a real application, this would come from an API or database
  const projects = [
    {
      id: 1,
      title: {
        fr: 'Petrofac, Projet de développement Alrar',
        ar: 'مشروع تطوير الرار - بتروفاك',
        en: 'Petrofac, Alrar Development Project'
      },
      category: {
        fr: 'Pétrole et Gaz',
        ar: 'النفط والغاز',
        en: 'Oil & Gas'
      },
      image: 'https://drive.google.com/thumbnail?id=1LRw3ML7-_-Ffc8LoLWNrqIsM-wTXhZD4&sz=w1000',
      description: {
        fr: 'Cette visite avait pour objectif de vérifier et approuver l\'emplacement et l\'orientation des buses sur la tuyauterie installée, et d\'assister et superviser lors de la mise en page, du perçage et de l\'installation des buses, en s\'assurant qu\'elles sont correctement installées selon les exigences d\'installation de Baker Hughes.',
        ar: 'هدفت هذه الزيارة إلى التحقق من الموقع والاتجاه للفتحات على الأنابيب المثبتة والموافقة عليها، وللمساعدة والإشراف أثناء التخطيط والحفر وتركيب الفتحات، مع ضمان تركيبها بشكل صحيح وفقًا لمتطلبات التثبيت الخاصة بشركة Baker Hughes.',
        en: 'This visit intended to verify and approve the location and orientation of the Nozzles on the installed piping and to assist, supervise during layout, drilling and installation of the nozzles, ensuring, they are correctly installed according to Baker Hughes installation requirements.'
      },
      tags: ['nozzles', 'installation', 'supervision', 'baker-hughes'],
      date: '2024'
    },
    {
      id: 2,
      title: {
        fr: 'Formation GTFT',
        ar: 'تدريب GTFT',
        en: 'GTFT Training'
      },
      category: {
        fr: 'Formation',
        ar: 'التدريب',
        en: 'Training'
      },
      image: 'https://drive.google.com/thumbnail?id=1s2m67laMelNoV7C6NekWUKoli0-zi7bP&sz=w1000',
      description: {
        fr: 'Formation du personnel GTFT, département production et opérations, sur le débitmètre de gaz non intrusif, modèle CTF878.',
        ar: 'تدريب موظفي GTFT، قسم الإنتاج والعمليات، على مقياس تدفق الغاز غير المتداخل، طراز CTF878.',
        en: 'Training of GTFT personnel, production and operations department, on the non-intrusive gas flow meter, model CTF878.'
      },
      tags: ['training', 'gas-flow-meter', 'CTF878', 'non-intrusive'],
      date: '2024'
    },
    {
      id: 3,
      title: {
        fr: 'Projets Groupement Sonatrach Enie MLE SITE',
        ar: 'مشاريع تجمع سوناطراك إيني MLE SITE',
        en: 'Projects Groupement Sonatrach Enie MLE SITE'
      },
      category: {
        fr: 'Pétrole et Gaz',
        ar: 'النفط والغاز',
        en: 'Oil & Gas'
      },
      image: 'https://drive.google.com/thumbnail?id=16Qkq4C5-FMIFVDtwkZk-2C5_P_wqEEst&sz=w1000',
      description: {
        fr: 'Installation d\'un débitmètre de gaz, modèle GC868, pour mesurer la consommation de gaz de la centrale électrique Sonatrach BBK.',
        ar: 'تركيب مقياس تدفق الغاز، طراز GC868، لقياس استهلاك الغاز لمحطة الطاقة سوناطراك BBK.',
        en: 'Installation of a gas flow meter, model GC868, for measuring gas consumption by the Sonatrach BBK power plant.'
      },
      tags: ['gas-flow-meter', 'GC868', 'sonatrach', 'power-plant', 'installation'],
      date: '2024'
    },
    {
      id: 4,
      title: {
        fr: 'Sonatrach CP2K',
        ar: 'سوناطراك CP2K',
        en: 'Sonatrach CP2K'
      },
      category: {
        fr: 'Pétrole et Gaz',
        ar: 'النفط والغاز',
        en: 'Oil & Gas'
      },
      image: 'https://drive.google.com/thumbnail?id=1rg0CttzzGxzZ1PVp5D_UklgaDvM6Bogf&sz=w1000',
      description: {
        fr: 'Configuration et mise en service d\'un enregistreur de données ABB.',
        ar: 'تكوين وتشغيل مسجل البيانات ABB.',
        en: 'Configuration and commissioning of ABB data Logger.'
      },
      tags: ['configuration', 'commissioning', 'ABB', 'data-logger', 'sonatrach'],
      date: '2024'
    },
    {
      id: 5,
      title: {
        fr: 'Sonatrach GL2Z - Mesure CO2',
        ar: 'سوناطراك GL2Z - قياس CO2',
        en: 'Sonatrach GL2Z - CO2 Measurement'
      },
      category: {
        fr: 'Pétrole et Gaz',
        ar: 'النفط والغاز',
        en: 'Oil & Gas'
      },
      image: 'https://drive.google.com/thumbnail?id=1liPukSJEgQ4ycdgXE1ORGb4I5slQJ7io&sz=w1000',
      description: {
        fr: 'Installation, supervision et mise en service de 6 débitmètres à ultrasons utilisés pour mesurer le volume de CO2.',
        ar: 'تركيب وإشراف وتشغيل 6 مقاييس تدفق بالموجات فوق الصوتية لقياس حجم ثاني أكسيد الكربون.',
        en: 'Installation, Supervision and commissioning of 6 ultrasonic FLOW METER used to measure volume of CO2.'
      },
      tags: ['installation', 'supervision', 'commissioning', 'ultrasonic', 'flow-meter', 'CO2', 'sonatrach'],
      date: '2024'
    },
    {
      id: 6,
      title: {
        fr: 'Sonatrach GL2Z - Débitmètres de Torche',
        ar: 'سوناطراك GL2Z - مقاييس تدفق الشعلة',
        en: 'Sonatrach GL2Z - Flare Flow Meters'
      },
      category: {
        fr: 'Pétrole et Gaz',
        ar: 'النفط والغاز',
        en: 'Oil & Gas'
      },
      image: 'https://drive.google.com/thumbnail?id=1eQ887ruXqS07uR7VCrqi8GjxqEoNUBPX&sz=w1000',
      description: {
        fr: 'Installation, supervision et mise en service de 2 débitmètres à ultrasons pour torche.',
        ar: 'تركيب وإشراف وتشغيل 2 مقياس تدفق بالموجات فوق الصوتية للشعلة.',
        en: 'Installation, Supervision and commissioning of 2 ultrasonic Flare Flow Meters.'
      },
      tags: ['installation', 'supervision', 'commissioning', 'ultrasonic', 'flare', 'flow-meter', 'sonatrach'],
      date: '2024'
    },
  ];

  // Get unique categories
  const categories = [
    { id: 'all', name: { fr: 'Tous', ar: 'الكل', en: 'All' } },
    ...Array.from(
      new Set(projects.map(project => project.category.fr))
    ).map(category => ({
      id: category.toLowerCase().replace(/\s+/g, '-'),
      name: {
        fr: category,
        ar: projects.find(p => p.category.fr === category)?.category.ar || category,
        en: projects.find(p => p.category.fr === category)?.category.en || category
      }
    }))
  ];

  // Filter projects based on active category
  const filteredProjects = activeCategory === 'all'
    ? projects
    : projects.filter(project => 
        project.category.fr.toLowerCase().replace(/\s+/g, '-') === activeCategory);

  // Reset visible items when category changes
  useEffect(() => {
    setVisibleItems(6);
  }, [activeCategory]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true);
        }
      },
      { threshold: 0.1 }
    );

    const section = document.querySelector('.projects-gallery-section');
    if (section) {
      observer.observe(section);
    }

    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="projects-gallery-section section section-light" style={{
      padding: '5rem 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        padding: '0 2rem'
      }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '3rem'
        }}>
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            marginBottom: '1.5rem',
            color: '#1a202c',
            position: 'relative',
            display: 'inline-block'
          }}>
            {language === 'fr' ? 'Nos Projets Récents' : 
             language === 'ar' ? 'مشاريعنا الحديثة' : 
             'Our Recent Projects'}
            <span style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: 'var(--assco-orange)',
              borderRadius: '2px'
            }}></span>
          </h2>
          <p style={{
            fontSize: '1.125rem',
            color: '#4a5568',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.7'
          }}>
            {language === 'fr' 
              ? 'Découvrez quelques-uns de nos projets phares réalisés récemment pour nos clients dans divers secteurs industriels.' 
              : language === 'ar'
              ? 'اكتشف بعض مشاريعنا الرائدة التي تم تنفيذها مؤخرًا لعملائنا في مختلف القطاعات الصناعية.'
              : 'Discover some of our flagship projects recently completed for our clients across various industrial sectors.'}
          </p>
        </div>

        {/* Categories Filter */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '0.75rem',
          marginBottom: '3rem',
          position: 'relative',
          zIndex: 10
        }}>
          {categories.map(category => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              style={{
                padding: '0.75rem 1.5rem',
                borderRadius: '30px',
                border: 'none',
                backgroundColor: activeCategory === category.id ? '#ee6c2f' : '#e2e8f0',
                color: activeCategory === category.id ? 'white' : '#4a5568',
                fontWeight: '600',
                fontSize: '0.95rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                position: 'relative',
                zIndex: 10,
                pointerEvents: 'auto',
                userSelect: 'none',
                outline: 'none'
              }}
              onMouseOver={(e) => {
                if (activeCategory !== category.id) {
                  e.currentTarget.style.backgroundColor = '#cbd5e0';
                }
              }}
              onMouseOut={(e) => {
                if (activeCategory !== category.id) {
                  e.currentTarget.style.backgroundColor = '#e2e8f0';
                }
              }}
            >
              {language === 'fr' ? category.name.fr : 
               language === 'ar' ? category.name.ar : 
               category.name.en}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
          gap: '2rem',
          opacity: isIntersecting ? 1 : 0,
          transform: `translateY(${isIntersecting ? '0' : '30px'})`,
          transition: 'opacity 0.6s ease, transform 0.6s ease',
        }}>
          {filteredProjects.slice(0, visibleItems).map((project, index) => (
            <div 
              key={project.id} 
              style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                opacity: isIntersecting ? 1 : 0,
                transform: isIntersecting ? 'translateY(0)' : 'translateY(30px)',
                animationDelay: `${index * 0.1}s`,
                animationDuration: '0.6s',
                animationFillMode: 'forwards'
              }}
              className="project-card"
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.06)';
              }}
            >
              <div style={{
                height: '240px',
                overflow: 'hidden',
                position: 'relative'
              }}>
                {/* Project Image */}
                <div style={{
                  width: '100%',
                  height: '100%',
                  backgroundImage: `url(${project.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}>
                </div>
              </div>
              
              <div style={{
                padding: '1.5rem'
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '0.75rem'
                }}>
                  <span style={{
                    color: 'var(--assco-orange)',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em'
                  }}>
                    {language === 'fr' ? project.category.fr : 
                     language === 'ar' ? project.category.ar : 
                     project.category.en}
                  </span>
                </div>
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '700',
                  marginBottom: '1rem',
                  color: '#1a202c',
                  lineHeight: '1.4'
                }}>
                  {language === 'fr' ? project.title.fr : 
                   language === 'ar' ? project.title.ar : 
                   project.title.en}
                </h3>
                <p style={{
                  fontSize: '1rem',
                  color: '#4a5568',
                  marginBottom: '1.5rem',
                  lineHeight: '1.6'
                }}>
                  {language === 'fr' ? project.description.fr : 
                   language === 'ar' ? project.description.ar : 
                   project.description.en}
                </p>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <Link 
                    to={`/projects/${project.id}`} 
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      color: 'var(--assco-orange)',
                      fontWeight: '600',
                      fontSize: '0.95rem',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.color = '#e05d0c';
                      const svg = e.currentTarget.querySelector('svg');
                      if (svg) {
                        svg.style.transform = 'translateX(5px)';
                      }
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.color = 'var(--assco-orange)';
                      const svg = e.currentTarget.querySelector('svg');
                      if (svg) {
                        svg.style.transform = 'translateX(0)';
                      }
                    }}
                  >
                    {language === 'fr' ? 'Voir les détails' : 
                     language === 'ar' ? 'عرض التفاصيل' : 
                     'View details'}
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="16" 
                      height="16" 
                      viewBox="0 0 20 20" 
                      fill="currentColor"
                      style={{ transition: 'transform 0.3s ease' }}
                    >
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {filteredProjects.length > visibleItems && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '3rem'
          }}>
            <button 
              onClick={() => setVisibleItems(prevCount => prevCount + 3)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.75rem',
                backgroundColor: 'white',
                color: '#1a202c',
                padding: '0.75rem 2rem',
                borderRadius: '30px',
                fontWeight: '600',
                fontSize: '1rem',
                border: '2px solid #e2e8f0',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
                position: 'relative',
                zIndex: 10,
                pointerEvents: 'auto'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#f7fafc';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'white';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.05)';
              }}
            >
              {language === 'fr' ? 'Charger plus de projets' : 
               language === 'ar' ? 'تحميل المزيد من المشاريع' : 
               'Load more projects'}
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="16" 
                height="16" 
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        )}
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .project-card {
          animation-name: fadeInUp;
        }
      `}</style>
    </section>
  );
};

export default ProjectsGallerySection;
